import {Component, HostListener, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {ArticlesService} from '../../../shared/service/articles.service';
import {OwlOptions} from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit {
  currLang = this._translate.currentLang;
  articles;
   showCarousel:boolean = false;
  articleDetails;
  articleId;
  baseImageUrl = environment.baseImageUrl;
  idParam;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    autoplay:true,
    navSpeed: 600,
    navText: ['&#8249', '&#8250;'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      760: {
        items: 3
      },
      1000: {
        items: 4
      }
    },
  }
  screenWidth: number;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.screenWidth = window.innerWidth;
    if(this.screenWidth <= 638) {
      this.showCarousel = true;
    }else {
      this.showCarousel = false;
    }
  }

  constructor(public _translate: TranslateService,
              private _articleService: ArticlesService,
              private route: ActivatedRoute,
              private router: Router) {
    this.screenWidth = window.innerWidth;
    if(this.screenWidth <= 638) {
      this.showCarousel = true;
    }else {
      this.showCarousel = false;
    }
    this.articleId = this.route.snapshot.paramMap.get('id');
    this.route.params.subscribe(
      (params: Params) => {
        this.getArticleById(params['id']);
        this.articleId = params['id']
      });
    this.getArticles();

  }

  ngOnInit(): void {
  }

  getArticles() {
    this._articleService.getArticles().subscribe((res) => {
      let articles = res.data;
      this.articles = articles.filter((article) => article.id !== this.articleDetails?.id);
    });
  }

  getArticleById(articleId) {
    this._articleService.getArticleDetails(articleId).subscribe((res) => {
      this.articleDetails = res.data;
    });
  }


  navigateToArticle(articleId) {
    this.router.navigateByUrl(this.router.url.replace(this.articleId, articleId));
  }
}
